import {addFormOperation} from '../../../_shared/GWTBridge/invoke/netForm';
import {buildFormServerCall} from '../../services/formService';

import {getStateXml} from '../../../_shared/GWTBridge/invoke/server';
import {Keys} from '../consts/keys';
import {formsStore} from '../stores/FormsStore';

export function activate() {
    const {currentForm} = formsStore;

    addFormOperation({
        ...currentForm.formState,
        key: Keys.None,
        isActive: '0'
    });

    const methodName = 'FormAutomaticActivate';
    const reason = 'Form Automatic Activate';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml]
    };

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function saveRowSubform() {
    const {currentForm} = formsStore;

    const methodName = 'FormActivate';
    const reason = 'saveReconSubformRow';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        before: ['true']
    };

    return buildFormServerCall(methodName, parameters, reason, true, false);
}
